import http from '@/utils/http'

export default {
  // 获取省份接口
  getProvinceList () {
    return http.get('/promotion/v1/api/region/province')
  },
  // 获取市接口
  getCity (value) {
    return http.get('/promotion/v1/api/region/city?province=' + value)
  },
  // 保存客户信息
  saveLawyer (params, type) {
    if (type === 'user') {
      return http.post('/yuan-admin/api/v1/customer/potential/addPotentialCustomer?id=' + params.id + '&name=' + params.name + '&phone=' + params.phone + '&remark=' + params.remark + '&origin=' + params.origin)
    } else {
      return http.post('/promotion/v1/api/lawyer/OfficialWebsite/saveLawyer', params)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/join-us-detail/api/index.js